module.exports = __webpack_public_path__ + "static/img/mobile-web-img@t.9550d6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/mobile-web-img@t.png
// module id = I9pt
// module chunks = 0